<template>
  <div class="the-navbar__user-meta items-center custom-nav">
    <ul>
      <li :key="idx" v-for="(item, idx) in menuItems" v-if="item.hasPermission">
        <a
          style="cursor: pointer"
          @click.stop="changeService(item, idx)"
          :class="{ active: idx === currentMenu }"
          >{{ item.name }}</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    currentMenu() {
      return this.$store.state.themeProps.currentMenu;
    },

    menuItems() {
      /*return this.$store.state.themeProps.menuItems.filter((e) =>
        !e.permission || this.$AuthService.hasPermission(e.permission)
      );*/
      return this.$store.state.themeProps.menuItems.map((e) => {
        return {
          ...e,
          hasPermission:
            !e.permission || this.$AuthService.hasPermission(e.permission),
        };
      });
    },
  },
  methods: {
    filterSubItems(service, items) {
      return items.filter(
        (item) =>
          item.permission === null ||
          item.header ||
          (service.permissionType === "entity"
            ? this.$AuthService.hasPermissionForActiveVenue(item.permission)
            : this.$AuthService.hasPermission(item.permission))
      );
    },
    changeService(service, idx) {
      this.$store.commit("UPDATE_SELECTED_MENU", idx);
      const availMenuItems = service.submenuItems
        .map((e) => ("submenu" in e && e.submenu.length > 0 ? e.submenu[0] : e))
        .filter(
          (item) =>
            item.permission === null ||
            item.header ||
            (service.permissionType === "entity"
              ? this.$AuthService.hasPermissionForActiveVenue(item.permission)
              : this.$AuthService.hasPermission(item.permission))
        )
        .map((e) =>
          e.header ? { ...e, items: this.filterSubItems(service, e.items) } : e
        );
      if (availMenuItems.length < 1) {
        console.error("No menu items availiable");
        return;
      }
      let item = availMenuItems[0];
      if (item.header) {
        item = item.items[0];
      }

      this.$router.push(item.url).catch((e) => {
        console.log("Redirect error", e);
      });
    },
  },

  data() {
    return {};
  },
};
</script>
<style scoped>
@font-face {
  font-family: "HelNeue";
  src: url("./fonts/Helvetica-Neue-Condensed-Bold.woff") format("woff"),
    /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
      url("./fonts/Helvetica-Neue-Condensed-Bold.ttf") format("truetype"); /* Chrome 4+, Firefox 3.5, Opera 10+, Safari 3—5 */
}

ul {
  height: 100%;
  display: flex;
  align-items: center;
}

li {
  flex: 1;
  display: inline-block;
  text-align: center;
  align-items: center;
}

li a {
  color: white;
  text-decoration: none;
  font-family: HelNeue;
  font-size: 16px;
  text-transform: uppercase;
  padding-bottom: 5px;
  border-bottom: 3px solid transparent;
}

li a.active {
  border-bottom: 3px solid #ffd74c;
}

li a:hover {
  border-bottom: 3px solid #ffd74c;
}

.custom-nav {
  height: 45px;
  min-width: 60%;
}

@media only screen and (max-width: 1140px) {
  .custom-nav {
    min-width: 90%;
  }
}
</style>
